/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {APP_BASE_HREF} from "@angular/common";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbAlertModule,
  NbCardModule,
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import {LoginComponent} from './auth/containers/login/login.component';
import {TokenInterceptor} from './auth/token.interceptor';
import {RecoveryComponent} from "./auth/containers/recovery/recovery.component";
import {RegisterComponent} from "./auth/containers/register/register.component";
import {AppService} from "./app.service";
import {ErrorAutenticateInterceptor} from "./auth/ErrorAutenticateInterceptor";
import {NfcNormalizeInterceptor} from "./@core/interceptors/nfc-normalize.interceptor";
import {AuthService} from './auth/services/auth.service';
import {ToastrModule} from "ngx-toastr";
import {SweetAlert2Module} from "@sweetalert2/ngx-sweetalert2";


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RecoveryComponent,
    RegisterComponent,
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NbAlertModule,
        SweetAlert2Module.forRoot(),
        ToastrModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        CoreModule.forRoot(),
        ThemeModule.forRoot(),
        NbCardModule,
    ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  providers: [
    AppService,
    {
      provide: APP_BASE_HREF, useValue: '/'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorAutenticateInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NfcNormalizeInterceptor,
      multi: true,
    },
    {
      // Al arrancar (incluido F5) se refrescan los permisos del usuario con sesión abierta,
      // para que los cambios hechos por el administrador se vean sin volver a iniciar sesión.
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService],
      useFactory: (auth: AuthService) => () => auth.refreshPermissions().toPromise(),
    },
  ],
})
export class AppModule {
}
